export default [
    {
        title: 'personas.menu_title',
        icon: 'UsersIcon',
        resource: 'Personas',
        action: 'ver-personas',
        children: [
            {
                title: 'global.menu.dashboard',
                icon: 'LayoutIcon',
                resource: 'Personas',
                action: 'ver-personas-dashboard',
            },
            {
                title: 'global.menu.configuracion',
                icon: 'SettingsIcon',
                resource: 'Personas',
                action: 'ver-personas-configuracion',
            },
            {
                title: 'global.menu.mantenimiento',
                icon: 'EditIcon',
                resource: 'Personas',
                action: 'ver-personas-mantenimiento',
                children: [
                    {
                        route: 'personas-lista-persona',
                        title: 'personas.subopciones.lista_personas',
                        resource: 'Personas',
                        action: 'ver-personas-lista-personas',
                    },
                    {
                        route: 'personas-crear-persona',
                        title: 'personas.subopciones.crear_personas',
                        resource: 'Personas',
                        action: 'ver-personas-crear-personas',
                    },
                    {
                        route: 'personas-mantenimiento-listado-entidades',
                        title: 'personas.subopciones.lista_entidades',
                        resource: 'Personas',
                        action: 'ver-personas-mantenimiento-listado-entidades',
                    },
                    {
                        route: 'personas-mantenimiento-cuentas-contables',
                        title: 'personas.subopciones.cuentas_contables',
                        resource: 'Personas',
                        action: 'ver-personas-mantenimiento-cuentas-contables',
                    },
                    {
                        route: 'personas-mantenimiento-cliente-local',
                        title: 'personas.subopciones.cliente_local',
                        resource: 'Personas',
                        action: 'ver-personas-mantenimiento-cliente-local',
                    },
                    {
                        route: 'personas-mantenimiento-permisos-categoria',
                        title: 'personas.subopciones.permisos_categoria',
                        resource: 'Personas',
                        action: 'ver-personas-mantenimiento-permisos-categoria',
                    },
                ],
            },
            {
                title: 'global.menu.transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Personas',
                action: 'ver-personas-transacciones',
                children: [
                    {
                        route: 'personas-transacciones-chequeo-personal',
                        title: 'personas.subopciones.chequeo_personal',
                        resource: 'Personas',
                        action: 'ver-personas-transacciones-chequeo-personal',
                    },
                ],
            },
            {
                title: 'global.menu.informes',
                fontIcon: 'file-prescription',
                resource: 'Personas',
                action: 'ver-personas-informes',
            },
        ],
    },
]
